/**
 * On-demand fonts for everything that is not inline in public/index.html.
 *
 * Tajawal + Cairo (the default storefront fonts) are self-hosted: their @font-face rules are inline in
 * public/index.html. Everything else used to be pulled in by render-blocking @import rules inside main.css
 * (Catalog.css, Sidebar.css, Dashboard.css) and <link>s in index.html, i.e. on every public catalog visit.
 * Now each font is a normal <link rel="stylesheet"> inserted from JS (never render-blocking), only where needed:
 *   stack  Almarai / IBM Plex Sans Arabic / Noto Kufi Arabic: the storefront font choices besides Tajawal/Cairo.
 *          Self-hosted (/fonts/stack-*.css). On first load the server shell already links the chosen one in
 *          <head> (_seo_font_link in catalog_backend/main.py, same data-font-group id); this covers editor mode.
 *   ui     Inter + Readex Pro   dashboard / studio screens (PrivateRoute, catalog in editor mode); Google Fonts
 *   studio Sora + DM Mono       catalog studio chrome (editor mode only); Google Fonts
 */
const GOOGLE_GROUPS = {
  ui: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Readex+Pro:wght@400;500;600;700;800&display=swap",
  studio:
    "https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Sora:wght@400;500;600;700&display=swap",
};

/**
 * catalog_font_stack value (see catalogFontFamilyFromStackKey) -> self-hosted stylesheet.
 * Keep in sync with _SEO_STACK_FONTS in catalog_backend/main.py and scripts/build_local_fonts.py (CSS_VERSION).
 */
const FONT_STACK_CSS = {
  almarai: "/fonts/stack-almarai.v1.css",
  ibm_plex_arabic: "/fonts/stack-ibm_plex_arabic.v1.css",
  noto_kufi: "/fonts/stack-noto_kufi.v1.css",
};

function addLink(id, href) {
  if (typeof document === "undefined") return;
  // the server shell may already have linked this font (same data-font-group), or we did earlier
  if (document.querySelector(`link[data-font-group="${id}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-font-group", id);
  document.head.appendChild(link);
}

export function ensureFontGroup(name) {
  if (GOOGLE_GROUPS[name]) addLink(name, GOOGLE_GROUPS[name]);
}

/** Loads the (self-hosted) font behind a storefront `catalog_font_stack` choice, if it needs one. */
export function ensureCatalogFontStack(stackKey) {
  const key = String(stackKey || "").toLowerCase();
  if (FONT_STACK_CSS[key]) addLink(`stack-${key}`, FONT_STACK_CSS[key]);
}

/** Editor mode: the font picker previews every choice, and the studio chrome uses Sora / DM Mono / Inter / Readex Pro. */
export function ensureAllStudioFonts() {
  ensureFontGroup("ui");
  ensureFontGroup("studio");
  Object.keys(FONT_STACK_CSS).forEach(ensureCatalogFontStack);
}
